import React from 'react';
import '../styles/partnership.css';

/* ── Partner Data ── Replace image with real logo imports later ── */
const partners = [
  { id: 1, name: 'Company 1' },
  { id: 2, name: 'Company 2' },
  { id: 3, name: 'Company 3' },
  { id: 4, name: 'Company 4' },
];

const benefits = [
  {
    icon: '🤝',
    title: 'Co-Research Opportunities',
    desc: 'Collaborate on cutting-edge agricultural research projects with joint IP ownership and publication rights.',
  },
  {
    icon: '🌍',
    title: 'Global Network Access',
    desc: 'Gain entry to an international network of research institutions, policymakers, and agri-tech innovators.',
  },
  {
    icon: '📢',
    title: 'Brand Visibility',
    desc: 'Feature your logo across our platforms, events, and publications reaching thousands of global stakeholders.',
  },
  {
    icon: '💡',
    title: 'Technology Transfer',
    desc: 'Access cutting-edge technologies developed through our research initiatives and field programs.',
  },
  {
    icon: '📊',
    title: 'Data & Insights',
    desc: 'Receive exclusive reports, datasets, and market intelligence from ongoing research programs.',
  },
  {
    icon: '🎓',
    title: 'Capacity Building',
    desc: 'Joint workshops, training programs, and knowledge exchange sessions for your teams.',
  },
];

/* ── Component ── */
const Partnership = () => {

  return (
    <div className="partnership-page">

      {/* ── Hero ── */}
      <section className="partnership-hero">
        <div className="hero-eyebrow">
          <span /> Global Partnerships
        </div>
        <h1>
          Growing Together,<br />
          <em>Impacting the World</em>
        </h1>
        <p>
          We collaborate with leading institutions, governments, and organisations worldwide
          to advance sustainable agriculture and food security.
        </p>
        <div className="hero-cta-group">
          <a href="/contact" className="btn-gold">
            Become a Partner →
          </a>
          <a href="#our-partners" className="btn-ghost">
            View Partners ↓
          </a>
        </div>
      </section>

      {/* ── Stats Strip ── */}
      <div className="stats-strip">
        <div className="stat-item">
          <div className="stat-number">50<span>+</span></div>
          <div className="stat-label">Partner Organisations</div>
        </div>
        <div className="stat-item">
          <div className="stat-number">30<span>+</span></div>
          <div className="stat-label">Countries Covered</div>
        </div>
        <div className="stat-item">
          <div className="stat-number">12<span>+</span></div>
          <div className="stat-label">Years of Collaboration</div>
        </div>
        <div className="stat-item">
          <div className="stat-number">100<span>+</span></div>
          <div className="stat-label">Joint Projects</div>
        </div>
      </div>

      {/* ── Partner Grid ── */}
      <section id="our-partners">
        <div className="section-wrap">
          <div className="section-header">
            <span className="section-tag">Our Partners</span>
            <h2>Trusted by Leading Organisations</h2>
            <p>
              We work with a wide range of universities, governments, and businesses who all share the same goal.
            </p>
          </div>

          <div className="partner-grid">
            {partners.map((partner, idx) => (
              <div
                className="partner-card"
                key={partner.id}
                style={{ animationDelay: `${idx * 0.08}s` }}
              >
                {/* Logo box — swap for <img src={partner.image} alt={partner.name} /> when ready */}
                <div className="partner-logo-wrap">
                  <div className="partner-logo-placeholder" />
                </div>
                <div className="partner-name">{partner.name}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Benefits Section ── */}
      <section className="benefits-bg">
        <div className="section-wrap">
          <div className="section-header">
            <span className="section-tag" style={{ background: 'rgba(200,168,75,0.18)', color: '#c8a84b' }}>
              Why Partner With Us
            </span>
            <h2 style={{ color: '#fff' }}>Partnership Benefits</h2>
            <p style={{ color: 'rgba(255,255,255,0.6)' }}>
              Our partnership framework is designed to create mutual value,
              accelerate impact, and build lasting relationships.
            </p>
          </div>
          <div className="benefits-grid">
            {benefits.map((b, i) => (
              <div className="benefit-card" key={i}>
                <div className="benefit-icon">{b.icon}</div>
                <h3>{b.title}</h3>
                <p>{b.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CTA Banner ── */}
      <div className="cta-banner">
        <div>
          <h2>Ready to Join Our Network?</h2>
          <p>
            Reach out to our partnerships team to explore collaboration opportunities,
            funding models, and joint research programmes.
          </p>
        </div>
        <div className="cta-actions">
  <a href="/contact" className="btn-primary-green">
    Apply for Partnership →
  </a>

  <a href="/partnership-enquiry" className="btn-enquiry">
    Partnership Enquiry →
  </a>

  <a href="/about" className="btn-outline-green">
    Learn About Us
  </a>
</div>
      </div>

    </div>
  );
};

export default Partnership;